import { CustomizationEmailNotificationDefaults } from "@graylog/enterprise-api";
import { qualifyUrl } from "util/URLUtils";
import fetch from "logic/rest/FetchProvider";
export const fetchEmailTemplates = () => CustomizationEmailNotificationDefaults.getEmailNotificationDefaults();
export const updateEmailTemplates = (config) => {
  const url = qualifyUrl("/plugins/org.graylog.plugins.customization/email_notification_defaults");
  return fetch("POST", url, config);
};
